<template>
    <div class="row login-page">

        <a href="/" class="logo">
            <img src="/images/logo-planiteasy-invert.png" alt="Logo PlanitEasy.nl">
        </a>

        <div class="column medium-8 medium-centered large-6">
            <form class="log-in-form">
                <div class="loading" v-show="loading">
                    <font-awesome-icon :icon="['fas', 'spinner']" spin/>
                </div>

                <div class="text-center" v-if="pitDisabled">
                    <br><br><br>
                    <h3>PlanitEasy is (tijdelijk) niet beschikbaar.</h3>
                    <p><small>Kom later terug!</small></p>
                    <br><br>
                </div>

                <div v-else>
                    <slide-up-down :active="view == 'login'" :duration="500">
                        <div class="login-image">
                            <img src="/images/undraw_deliveries_131a.svg">
                        </div>

                        <h4 class="text-center">Inloggen bij Planit<strong>Easy</strong></h4>

                        <slide-up-down :active="!!timedout" :duration="500">
                            <b-notification type="is-warning">
                                Je bent automatisch uitgelogd wegens inactiviteit.
                            </b-notification>
                        </slide-up-down>

                        <slide-up-down :active="!!loginerror" :duration="500">
                            <b-notification type="is-danger" aria-close-label="Sluiten" role="alert">{{ loginerror != false ? loginerror : '' }}</b-notification>
                        </slide-up-down>

                        <b-field label="E-mailadres">
                            <b-input v-model="loginData.email" type="email" placeholder="mijn@emailadres.nl" @keyup.native.enter="submitLogin"></b-input>
                        </b-field>

                        <b-field label="Wachtwoord">
                            <b-input v-model="loginData.password" type="password" placeholder="******" @keyup.native.enter="submitLogin"></b-input>
                        </b-field>

                        <div class="button-wrap">
                            <b-button type="is-text" @click="toggleView">Wachtwoord vergeten?</b-button>
                            <b-button type="is-dark" @click="submitLogin">Inloggen</b-button>
                        </div>
                    </slide-up-down>

                    <slide-up-down :active="view == 'password'" :duration="500">
                        <div class="login-image">
                            <img src="/images/undraw_forgot_password_gi2d.svg">
                        </div>

                        <h4 class="text-center">Wachtwoord vergeten</h4>


                        <slide-up-down :active="!passwordsuccess" :duration="500">
                            <slide-up-down :active="!!passworderror" :duration="500">
                                <b-notification type="is-danger" aria-close-label="Sluiten" role="alert">{{ passworderror != false ? passworderror : '' }}</b-notification>
                            </slide-up-down>

                            <b-field label="E-mailadres">
                                <b-input v-model="loginData.email" type="email" placeholder="mijn@emailadres.nl" @keyup.native.enter="submitPasswordForgotten"></b-input>
                            </b-field>

                            <div class="button-wrap">
                                <b-button type="is-text" @click="toggleView">Terug naar inloggen</b-button>
                                <b-button type="is-dark" @click="submitPasswordForgotten">Verstuur nieuw wachtwoord</b-button>
                            </div>
                        </slide-up-down>
                        <slide-up-down :active="passwordsuccess" :duration="500">
                            <p>Er is een e-mail gestuurd naar {{ loginData.email }} voor je nieuwe wachtwoord!</p>

                            <div class="button-wrap text-center">
                                <b-button type="is-black" @click="toggleView">Terug naar inloggen</b-button>
                            </div>
                        </slide-up-down>
                    </slide-up-down>
                </div>
            </form>

            <p class="copyright">© Copyright {{ moment().format('Y') }} - PlanitEasy.nl - Alle rechten voorbehouden.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginBox',
    props: {
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        authenticating: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
            view: 'login',
            loginData: {
                email: '',
                password: ''
            },
            loginerror: false,
            timedout: false,

            passworderror: false,
            passwordsuccess: false,
            pitDisabled: false
        }
    },

    mounted () {
        if(this.pitDisabled) return false;

        const authtokenElement = document.getElementById('authtoken')
        if(authtokenElement && authtokenElement.value){
            this.$emit('setLoading', true)

            this.$emit('setLoading', true)
            this.setToken(authtokenElement.value).then(() => {
                this.loginerror = false
                authtokenElement.remove()

                // Emit login success event
                this.$emit('loginSuccess')

                // Set logged in state last
                this.$emit('setLoggedIn', true)
            }).catch((error) => {
                console.error('[❌] Error while logging in:', error)
                authtokenElement.remove()

                if (_.has(error, 'response.data.error')) {
                    this.loginerror = error.response.data.error
                } else {
                    this.loginerror = 'Er is een fout opgetreden bij het inloggen. Probeer het opnieuw.'
                }

                this.$emit('setLoading', false)
            })
        }

        // Check URL parameters for timedout or expired
        if(_.has(this.$route, 'query.timedout')){
            this.timedout = true
        } else if(_.has(this.$route, 'query.expired')){
            this.loginerror = 'Je sessie is verlopen. Log opnieuw in.'
        }
    },

    methods: {
        submitLogin(){
            // Prevent multiple submissions
            if (this.loading) return;

            this.$emit('setLoading', true)
            this.loginerror = false
            this.timedout = false

            // Check if credentials are provided
            if (!this.loginData.email || !this.loginData.password) {
                this.loginerror = 'Vul je e-mailadres en wachtwoord in.'
                this.$emit('setLoading', false)
                return;
            }

            // Set loading state to true to show the spinner over the login form
            this.$emit('setLoading', true);

            axios.post('/api/login', this.loginData)
                .then((response) => {
                    // Mark that the user has visited before for future sessions
                    localStorage.setItem('has_visited_before', 'true')

                    // First set the token and load the app
                    this.setToken(response.data.token).then(() => {
                                                // Reset form data
                        this.loginData.email = ''
                        this.loginData.password = ''

                        // Make sure loading state is reset
                        this.$emit('setLoading', false)

                        // Emit login success event with token and userData
                        const userData = localStorage.getItem('user_data')

                        // Emit to parent component
                        this.$emit('loginSuccess', response.data.token, userData)

                        // Also emit to $root to ensure it's caught
                        this.$root.$emit('loginSuccess', response.data.token, userData)

                        // Set logged in state last
                        this.$emit('setLoggedIn', true)
                    })
                })
                .catch((error) => {
                    console.error('[❌] Error while logging in:', error)
                    this.loginData.password = ''

                    if(error && error.response) {
                        // Handle HTTP error responses
                        if (error.response.status === 401) {
                            console.error('[❌] Authentication failed (401 Unauthorized)')
                            this.loginerror = error.response.data.error || 'Ongeldige inloggegevens.'
                        } else {
                            // Handle other HTTP errors
                            this.loginerror = error.response.data.error || 'Er is een fout opgetreden bij het inloggen.'
                        }
                    } else if (error.message && error.message.includes('token')) {
                        // Handle token-related errors
                        this.loginerror = 'Er is een probleem met de authenticatie. Probeer het opnieuw.'
                    } else {
                        // Handle other errors
                        this.loginerror = 'Er is een fout opgetreden bij het inloggen. Probeer het opnieuw.'
                    }

                    // Turn off loading state
                    this.$emit('setLoading', false)
                })
        },

        submitPasswordForgotten(){
            this.$emit('setLoading', true)
            this.passworderror = false

            axios.post('/api/wachtwoord-vergeten', {'email': this.loginData.email})
            .then((response) => {
                this.passwordsuccess = true
            }).catch((error) => {
                this.passworderror = error.response.data.error
                this.loginData.email = ''
            }).then(() => {
                this.$emit('setLoading', false)
            })
        },

        setToken(token){
            return new Promise((resolve, reject) => {
                this.$store.dispatch('setToken', token)
                    .then(() => {
                        // After setting token, load the app
                        return this.$store.dispatch('loadApp')
                    })
                    .then((response) => {
                        if(response == 'loaded'){
                            // App loaded successfully
                            resolve()
                        } else {
                            // Something went wrong
                            reject(new Error('App failed to load'))
                        }
                    })
                    .catch((error) => {
                        console.error('[❌] Error in setToken flow:', error)
                        reject(error)
                    })
            })
        },

        toggleView(){
            this.view = this.view == 'login' ? 'password' : 'login'
            this.passwordsuccess = false
        }
    }

}
</script>